import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { 
  Batch, 
  ProcessState, 
  ProcessStateService 
} from '../../../swaggerServices';

@Injectable()
export class CurrentBatchService {

  private pollBatchId = null;
  private batchSource = new BehaviorSubject({});
  private batchCache = new BehaviorSubject({ clientId: null, batches: [] });
  private overridesCache = {};
  currentBatch = this.batchSource.asObservable();
  clientBatches = this.batchCache.asObservable();

  private taxReturnsWithWarnings = new BehaviorSubject({
    batchId: null,
    answerWarnings: [],
    count: null,
    taxReturns: [],
    taxReturnStructure: [],
    warningsByQuestionId: {},
    validationWarnings: [],
    questions: [],
    answers: [],
    flagsByQuestionId: {},
    flagAnswers: [],
    answerFlags: [],
    commentsByQuestionId: {},
    warningCountOnly: true
  });
  warningsObservable = this.taxReturnsWithWarnings.asObservable();

  constructor(private processStateService: ProcessStateService) { }

  changeBatch(batch: Batch) {
    this.batchSource.next(batch);
  }

  cacheClientBatches(clientId: number, batches: Batch[]) {
    this.batchCache.next({ clientId, batches });
  }

  setOverridesForBatch(batchId: number, overrides: any) {
    this.overridesCache[batchId] = overrides;
  }
  getOverridesForBatch(batchId: number) {
    return this.overridesCache[batchId];
  }

  setTaxReturnsWithWarnings(items) {
    this.taxReturnsWithWarnings.next(items);
  }

  retriggerGetWarningCount(batchId: number) {
    setTimeout(() => {
      this.pollBatchWarningCount(batchId);
    },3000)
  }

  // can only have one polling at a time so the last one wins
  pollBatchWarningCount(batchId: number) {
    this.pollBatchId = batchId;
    this.processStateService.getEntityProcessState('batchWarningCount', 'batch', batchId).subscribe(response => {
      if (batchId !== this.pollBatchId) { return; }
      const ps: ProcessState = response;
      if (!ps) { return; }

      if (ps.state && ps.state === "R") {
        this.retriggerGetWarningCount(batchId);
        return;
      }

      if (!ps.message) { return; }
      let message = { taxReturns: undefined, count: undefined, inProgress: undefined, state: undefined, remaining: undefined, total: undefined };
      try {
        message = JSON.parse(ps.message);
      } catch (err) {
        if (ps.state && ps.state === "R") {
          this.retriggerGetWarningCount(batchId);
          return;
        }
      }

      if (message.inProgress === false) {
        this.setTaxReturnsWithWarnings({
          ...message,
          batchId: batchId,
        });
      }
    });
  }
}
